import { NavLink } from "react-router-dom";

export const NavBarTab = ({ path, title, activeMenuItem }: { path: string; title: string; activeMenuItem: string; }) => {
    return (
        <li data-testid={path} role="menuitem" className={activeMenuItem === path ? "active" : ""}>
            <NavLink to={`/${path}`}>{title}</NavLink>
        </li>
    );
};
